export type Availability = "In Stock" | "Out of Stock"

export type InventoryItem = {
  id: string
  name: string
  category: string
  stockStatus: number
  availability: Availability
  expiration: string
  unitPrice: number
  uppStatus: "Active" | "Inactive"
  dispenseMode: "Prescription Only" | "Over the counter"
}

export const inventoryKpis = {
  totalMedications: 35,
  restockTimeHours: 10.2,
  refilledMeds: 22,
  inventoryAccuracyPct: 91,
}

export const recentMovement: InventoryItem[] = [
  { 
    id: "inv-1", 
    name: "Ibuprofen 200mg", 
    category: "Pain Relief", 
    stockStatus: 85, 
    availability: "In Stock", 
    expiration: "03/15/2026",
    unitPrice: 120,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-2", 
    name: "Metformin 500mg", 
    category: "DiabetesCare", 
    stockStatus: 90, 
    availability: "Out of Stock", 
    expiration: "01/10/2026",
    unitPrice: 130,
    uppStatus: "Active",
    dispenseMode: "Over the counter"
  },
  { 
    id: "inv-3", 
    name: "Lisinopril 10mg", 
    category: "HeartHealth", 
    stockStatus: 88, 
    availability: "In Stock", 
    expiration: "05/20/2026",
    unitPrice: 140,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-4", 
    name: "Simvastatin 20mg", 
    category: "CholesterolCo", 
    stockStatus: 91, 
    availability: "In Stock", 
    expiration: "07/30/2026",
    unitPrice: 190,
    uppStatus: "Active",
    dispenseMode: "Over the counter"
  },
  { 
    id: "inv-5", 
    name: "Levothyroxine 50mcg", 
    category: "ThyroidWell", 
    stockStatus: 84, 
    availability: "In Stock", 
    expiration: "09/01/2026",
    unitPrice: 150,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-6", 
    name: "Amlodipine 5mg", 
    category: "BloodPressurePlus", 
    stockStatus: 87, 
    availability: "In Stock", 
    expiration: "11/15/2026",
    unitPrice: 180,
    uppStatus: "Active",
    dispenseMode: "Over the counter"
  },
  { 
    id: "inv-7", 
    name: "Omeprazole 20mg", 
    category: "DigestiveHealth", 
    stockStatus: 82, 
    availability: "In Stock", 
    expiration: "04/22/2026",
    unitPrice: 900,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-8", 
    name: "Hydrochlorothiazide 25mg", 
    category: "FluidBalance", 
    stockStatus: 89, 
    availability: "In Stock", 
    expiration: "06/30/2026",
    unitPrice: 150,
    uppStatus: "Active",
    dispenseMode: "Over the counter"
  },
  { 
    id: "inv-9", 
    name: "Citalopram 20mg", 
    category: "MoodStabilizers", 
    stockStatus: 86, 
    availability: "In Stock", 
    expiration: "08/28/2026",
    unitPrice: 140,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-10", 
    name: "Gabapentin 300mg", 
    category: "NerveCare", 
    stockStatus: 83, 
    availability: "In Stock", 
    expiration: "12/15/2026",
    unitPrice: 200,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-11", 
    name: "Sertraline 50mg", 
    category: "MentalHealth", 
    stockStatus: 81, 
    availability: "In Stock", 
    expiration: "02/05/2026",
    unitPrice: 110,
    uppStatus: "Inactive",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-12", 
    name: "Tamsulosin 0.4mg", 
    category: "UrinaryHealth", 
    stockStatus: 80, 
    availability: "Out of Stock", 
    expiration: "03/30/2026",
    unitPrice: 160,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
  { 
    id: "inv-13", 
    name: "Furosemide 40mg", 
    category: "DiureticCare", 
    stockStatus: 78, 
    availability: "In Stock", 
    expiration: "05/14/2026",
    unitPrice: 90,
    uppStatus: "Active",
    dispenseMode: "Over the counter"
  },
  { 
    id: "inv-14", 
    name: "Atorvastatin 10mg", 
    category: "HeartSupport", 
    stockStatus: 79, 
    availability: "In Stock", 
    expiration: "07/19/2026",
    unitPrice: 210,
    uppStatus: "Active",
    dispenseMode: "Prescription Only"
  },
]

export const allInventory: InventoryItem[] = recentMovement
